import styled from "styled-components";
import { fadeIn } from "../../components/Common/CommonStyles";

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  animation: ${fadeIn} 0.2s ease-in;
`;

export const Section = styled.section`
  display: ${(props) => props.display || "flex"};
  align-items: ${({ align }) => {
    if (align === "left") return "flex-start";
    if (align === "center") return "center";
    if (align === "right") return "flex-end";
    return "flex-start";
  }};
  justify-content: ${(props) => props.justify || "center"};
  padding: ${(props) => props.padding || "0px"};
  flex-direction: ${(props) => props.flexDirection || "row"};
  max-width: ${({ maxWidth }) => maxWidth || ""};
  align-self:${({ alignSelf }) => alignSelf || ""};
  margin-left: :${({ marginLeft }) => marginLeft || ""};
  gap: ${({ gap }) => gap || "0px"};
  margin-top: ${({ marginTop }) => marginTop || "0px"};
  margin-bottom: ${({ marginBottom }) => marginBottom || "0px"};
`;
